export default __webpack_public_path__ + "images/SHA.b01e65e.png";